export const TaskField = Object.freeze({
	Accomplices: 'accomplicesIds',
	Auditors: 'auditorsIds',
	CheckList: 'checklist',
	CreatedDate: 'createdTs',
	Creator: 'creatorId',
	Crm: 'crmItemIds',
	DatePlan: 'datePlan',
	TimeTracking: 'allowsTimeTracking',
	Deadline: 'deadlineTs',
	Email: 'email',
	Files: 'fileIds',
	Flow: 'flowId',
	Gantt: 'gantt',
	Group: 'groupId',
	Parent: 'parentId',
	Placements: 'placements',
	RelatedTasks: 'relatedTasks',
	Reminders: 'reminders',
	Responsible: 'responsibleIds',
	Replication: 'replication',
	Results: 'results',
	Status: 'status',
	SubTasks: 'subTasks',
	Tags: 'tags',
	Title: 'title',
	UserFields: 'userFields',
});
